'use client';

import TypewriterCycle from '@/components/TextEffects/TypewriterCycle';
import { usePathname } from 'next/navigation';

const TYPEWRITER_WORDS = ['CREATIVES', 'SUITS', 'DEVELOPERS', 'PROGRAMMERS', 'ARTISTS', 'ILLUSTRATORS', 'DESIGNERS'];

const Intro = () => { // Wesley: hard check just so the landing page has a h1...
  const pathname = usePathname();
  const isLandingPage = pathname === '/';
  const IntroHeadingTag = isLandingPage ? 'h1' : 'h2';

  return (
    <div className='content-left-box'>
      <IntroHeadingTag className='text-gray letter-scrambler'>{`\\\\INTRO\\\\`}</IntroHeadingTag>
      <div>
        <p className='letter-scrambler'>
          WE RUN ON EXPERIMENTATION AND CREATIVITY.
          INVENTED FROM ADVERTISING AND PRODUCTION SPHERES,
          THE OTHER LAB THRIVES ON MATERIALISING IDEAS WITH A TEAM OF HIGHLY SKILLED
          <span> <TypewriterCycle words={TYPEWRITER_WORDS} /></span>
        </p>
      </div>
      <p className={'text-gray'}>{'<>'}</p>
    </div>
  )
};

export default Intro;
